module.exports = __webpack_public_path__ + "img/telegram.2ec05662.svg";